import Api from '../gd/api/api'
import ModalTaskLink from "./link-entity/task-link/task-link"
import Task from "../model2/task/task"
import {DependencyType} from "../model2/dependency/const"
import DatetimeUtils from "../gd/utils/datetime-utils"
import TaskStatusUpdateModal from "./task-status-update/task-status-update"
import TaskReminderModal from "./task-reminder/task-reminder"
import {BUS_TASK_UPDATE_BEFORE_API_CALL} from "../model2/task/@events"
import {modalMoveTask, modalMoveTaskToTask} from "./move-to/move"
import {modalCopyTask} from "./copy/copy"

// @ts-ignore
const modalRecurrence = () => import(/* webpackChunkName: "recurrence" */ './task-recurrence/task-recurrence-modal');

export default class TaskModalsManager {

    constructor() {}

    addTag(companyId:ID, taskObject:Task, existingTags:ID[], callback:callback, newOnly:boolean = false) {
        gd.modal.showV4({
            className: 'modal-tag',
            header: {
                title: 'Select Tag'
            },
            component: require('./tag/modal-tag.jsx'),
            params: {
                newOnly: newOnly,   // currently not in use yet
                tasks: [taskObject],
                companyId: companyId,
                tags: existingTags ? existingTags : [],
                callback: callback
            }
        });
    }

    addDependency(task:Task, dependsOn:any, dependentTasks:any, dependencyType?:DependencyType, callback?:callback) {
        gd.modals.dependency.addTaskDependency(task, dependsOn, dependentTasks, dependencyType, callback);
    }

    startEnd(task:Task, callback:callback) {
        gd.modal.showForm({
            className: 'modal-action-start-end',
            header: {
                title: 'Task Start / End'
            },
            component: require('./start-end-task/modal-action-stat-end.jsx'),

            params: {
                onSubmit: (values:any)=>{
                    const startDate : Moment|null = values.startDate ? values.startDate : null;
                    const endDate = values.endDate ? values.endDate : null;

                    gd.api.Task.startEnd(
                        task.id, startDate, endDate, task.scheduleDate, !!task.actionRequiredUserId, task.companyId,
                        (startDate:Moment|null, endDate:Moment|null, scheduleDate:Moment|null)=>{
                            task.startDate = startDate;
                            task.endDate = endDate;
                            if (scheduleDate) {
                                task.scheduleStatus = gd.const.task.scheduleStatus.SCHEDULED;
                                task.scheduleDate = scheduleDate;
                            }
                        },
                        (startDate:Moment|null, endDate:Moment|null, scheduleDate:Moment|null)=>{
                            if (callback) callback(task.id, startDate, endDate, scheduleDate);
                            gd.modal.hide();
                        }
                    );
                },
                task: task
            }
        });
    }

    moveToFolder(task:Task, callback?:callback) {
        return modalMoveTask(task, {
            callback: callback,
        })

        /*gd.modal.showV4({
            className: 'modal-move',
            component: ModalMoveTo,
            params: {
                taskId: taskId,
                parentTaskId: parentTaskId,
                parentProjectId: parentProjectId,
                companyId: companyId,
                arrTaskUsers: arrTaskUsers,
                mode: ModalMoveTo_Mode.TASK,
                type: ModalMoveTo_TargetType.FOLDER,
                onMove: callback
            }
        });*/
    }

    moveToTask(task:Task,  callback?:callback) {
        return modalMoveTaskToTask(task, {
            callback: callback,
        })

        /*gd.modal.showV4({
            className: 'modal-move',
            component: ModalMoveTo,
            params: {
                taskId: taskId,
                parentTaskId: parentTaskId,
                parentProjectId: parentProjectId,
                companyId: companyId,
                mode: ModalMoveTo_Mode.TASK,
                type: ModalMoveTo_TargetType.TASK,
                onMove: callback
            }
        });*/
    }

    deadline(task:Task, callback:callback) {
        gd.modal.showGeneric({
            className: 'modal-action-deadline',
            header: {
                title: 'Task Deadline'
            },
            // modalType: 'v3',
            // title: 'Deadline',
            component: require('./deadline-task/modal-action-deadline.jsx'),

            params: {
                onSubmit: (date:string)=>{

                    task.deadline = date ? DatetimeUtils.dateToMoment(date) : null
                    Api.Task.setDeadline(task.id, task.deadline);

                    if (callback) {
                        callback(task.id, task.deadline);
                    }
                    gd.modal.hide();
                },
                task: task,
                // this: this
            }
        });
    }


    progress(task:Task, callback:callback) {

        gd.modal.showGeneric({
            // modalType: 'v3',
            className: 'modal-progress',
            component: require('./progress/progress.jsx'),
            header: {
                title: 'Task Progress'
            },

            params: {
                onSubmit: (value:any)=>{
                    Api.Task.setProgress(task.id, value);
                    if (callback) callback(task.id, value);
                    gd.modal.hide();
                },
                task: task
            }
        });
    }


    estimate(task:Task, callback:callback) {
        gd.modal.showGeneric({

            className: 'modal-action-estimate',
            header: {
                title: 'Task Estimate'
            },
            // modalType: 'v3',
            // title: 'Estimate Task',
            component: require('./estimate-task/modal-action-estimate'),
            params: {
                onSubmit: (values:any)=>{
                    const estimate = values.hours * 60 + values.minutes;
                    task.estimate = estimate;
                    Api.Task.setEstimate(task.id, estimate);
                    if (callback) callback(task.id, estimate);

                    gd.modal.hide();
                },
                item: task,
                this: this
            }
        });
    }

    recurrence(taskId:ID , callback:callback , options:any = {}) {


        gd.modal.loadAndShow(modalRecurrence, false, {
            className: 'modal-task-recurrence',
            modalType: 'v4',
            toggleCallback: (isOpen:boolean) => {
                // console.log("toggle")
            },
            params: {
                taskId: taskId,
                onFinishCallback: ()=>{
                    gd.modal.hide();
                }
            }
        });
    }

    convertTaskType(task:Task, callback?:callback) {
        gd.modal.showForm({
            header: {
                title: 'Convert Task'
            },
            component: require('./edit-task/modal-edit-task'),
            params: {
                onSubmit: (values:any)=>{
                    // do nothing if same task type is selected
                    if (task.taskTypeId === values.taskType) {
                        gd.modal.hide()
                        return
                    }


                    gd.bus.triggerEvent(BUS_TASK_UPDATE_BEFORE_API_CALL)
                    // if (onBeforeApiCall) onBeforeApiCall(values.taskType, values.taskStatus);

                    const request = Api.Task.editTask(task.id, task.title, values.taskType, values.taskStatus);
                    request.done(()=>{
                        gd.modal.hide();
                        if (callback) callback(values.taskType, values.taskStatus)
                    })
                },
                task: task
            }
        });
    }

    deleteTask(task:Task, callback?:callback) {

        const comment = 'All task data, attachments, subtasks and time reports will be deleted as well.';

        gd.modals.confirm.deleteByNameWithComment('Task',task.title, comment, ()=>{
            if (callback) callback({deleteInProgress: true});
            const request = Api.Task.deleteTask(task.id);
            request.done((response:any)=>{
                gd.session.recent.tasks.tasksRemove(response);
                gd.modal.hide();
                if (callback) callback();
            });
        });

    }

    duplicate(task:Task, callback?:callback, options:any = {}) {
        const { redirectToCopy } = options

        modalCopyTask(task, {
            redirectToCopy,
            callback
        })
    }

    /*addUsers(companyId:ID, projectId:ID, taskUsers:any[], callback:callback, options={}) {

        gd.modal.showV4({
            className: 'modal-add-user',
            component: require('./add-user/add-user.jsx'),
            params: {
                onSubmit: (newUsers:any)=>{
                    if (callback) callback(newUsers);
                    gd.modal.hide();
                },
                multiselect: true,
                companyId: companyId,
                projectId: projectId,
                taskUsers: taskUsers,
                mode: 'task'
            }
        });
    }*/

    /*addUser2(task:Task, callback:callback) {
        gd.modal.showV4({
            className: 'modal-add-user',
            component: require('./add-user/add-user.jsx'),
            params: {
                onSubmit: (userId:ID, access:ProjectAccess, type:any)=>{

                    // add user here (!!!)
                    if (callback) callback(userId, access, type);
                    gd.modal.hide();
                },
                multiselect : false,
                companyId   : gd.companyId,
                projectId   : task.projectId,
                taskUsers   : task.users,
                mode        : 'task'
            }
        });
    }*/

    /*addUser(companyId:ID, projectId:ID, taskUsers:any[], callback:callback, options:any={}) {
        gd.modal.showV4({
            className: 'modal-add-user',
            component: require('./add-user/add-user.jsx'),
            params: {
                onSubmit: (userId:ID, access:ProjectAccess, type:any)=>{
                    if (callback) callback(userId, access, type);
                    gd.modal.hide();
                },
                multiselect: false,
                companyId: companyId,
                projectId: projectId,
                taskUsers: taskUsers,
                mode: 'task'
            }
        });
    }*/

    addTodoList(companyId:ID, callback:callback) {
        gd.modal.showV4({
            className: 'modal-add-todo-list',
            component: require('../gd-modals/task-todo-list/task-todo-list-modal'),
            params: {
                onSubmit: (name:string,items:any)=>{
                    if (callback) callback(name,items);
                    gd.modal.hide();
                },
                companyId: companyId
            }
        });
    }

    taskLink(projectId:ID|null, excludedTasksIds:ID[], callback:callback) {
        gd.modal.showV4({
            className: 'modal-task-link',
            component: ModalTaskLink,
            params: {
                projectId,
                excludedTasksIds,
                onSubmit: (result:any)=>{
                    if (callback) callback(result);
                    gd.modal.hide();
                },
            }
        });
    }

    statusUpdateRequest(task:Task) {
        gd.modal.showV4({
            className   : 'modal-status-update-request',
            component   : TaskStatusUpdateModal,
            params      : {
                task: task,
            }
        })
    }

    createReminder(task:Task, userId?: ID) {
        gd.modal.showV4({
            className   : 'modal-create-task-reminder',
            component   : TaskReminderModal,
            params      : {
                task    : task,
                userId  : userId,
            }
        })
    }
}
